import styled from 'styled-components';

export const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  font-family: 'Inter';
  overflow-y: auto;
  padding: 20px;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  font-family: 'Inter';
  margin: auto;
`;

export const ModalBody = styled.div`
  margin-bottom: 20px;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
`;

export const FileInfoHeader = styled.div`
  background: #f5f7fa;
  padding: 12px 16px;
  border-radius: 6px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const FileIcon = styled.div`
  font-size: 24px;
  color: #007bff;
  display: flex;
  align-items: center;
`;

export const FileDetails = styled.div`
  flex: 1;
  min-width: 0;
`;

export const FileName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const FileSize = styled.div`
  font-size: 12px;
  color: #666;
  margin-top: 2px;
`;

export const TreeContainer = styled.div`
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-top: 12px;
  min-height: 200px;
  max-height: 300px;
  overflow-y: auto;
`;

export const SelectedCount = styled.div`
  font-size: 13px;
  color: #007bff;
  font-weight: 600;
  padding: 8px 12px;
  background: #e7f3ff;
  border-radius: 4px;
  text-align: center;
`;

export const AgentSelectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 20px;
`;

export const SectionTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
`;

export const CurrentAgentRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
  border: 2px solid #e0e0e0;
`;

export const AgentAvatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  background: #ddd;
`;

export const AgentInfo = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;

export const AgentName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AgentDescription = styled.div`
  font-size: 12px;
  color: #666;
  margin-top: 2px;
`;

export const ExpandableHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  color: #555;
  border-radius: 6px;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: #f5f5f5;
  }
  
  svg {
    font-size: 20px;
  }
`;

export const AgentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 250px;
  overflow-y: auto;
  padding: 4px;
`;

export const AgentRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  background: white;
  transition: all 0.2s;
  
  &:hover {
    background-color: #f8f9fa;
    border-color: #007bff;
  }
`;

export const ValidationMessage = styled.div`
  font-size: 13px;
  color: #dc3545;
  padding: 8px 12px;
  background: #f8d7da;
  border-radius: 4px;
  border: 1px solid #f5c6cb;
`;

export const Checkbox = styled.input`
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #007bff;
`;

export const SectionDivider = styled.div`
  height: 1px;
  background: #e0e0e0;
  margin: 20px 0;
`;

